// import { resetRouter } from '@/router'
import { setToken, removeToken } from '@/utils/auth'
import { autoLogin, init, logout } from '@/api/login'
import router from '@/router'

const state = {
  token: '',
  user: null,
  permissions: [],
  menus: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USER: (state, user) => {
    state.user = user
  }
}

const actions = {
  login({ commit }, userInfo) {
    const { email, password } = userInfo
    return new Promise((resolve, reject) => {
      autoLogin({ email: email.trim(), password: password }).then(res => {
        const token = res.token_type + ' ' + res.access_token
        commit('SET_TOKEN', token)
        setToken(token)

        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  init({ commit }) {
    return new Promise((resolve, reject) => {
      init().then(async res => {
        commit('SET_USER', res.user)
        const accessRoutes = await this.dispatch('permission/generateRoutes', res)
        router.addRoutes(accessRoutes)
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  logout({ commit }) {
    return new Promise(resolve => {
      logout().then(res => {
        commit('SET_USER', null)
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      }).catch(res => {
        console.error(res)
      })
    })
  },
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
